import React from "react";
import Routes from "./Routes";
import { AuthProvider } from "./contexts/AuthContext";
import ViewportIndicator from './components/ViewportIndicator';

function App() {
  return (
    <AuthProvider>
      <>
        <Routes />
        <ViewportIndicator />
      </>
    </AuthProvider>
  );
}

export default App;